var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Icon } from "../Icon";
import { Button } from "../Button";
// styles
import "./tag.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-tag",
    dismissableIcon: "x",
    dismissable: false,
    disabled: false,
};
/**
 * A small label, generally appearing inside or in close proximity to another larger interface component, representing a status, property, or some other metadata.
 */
const Tag = (_a) => {
    var { label, iconName, dismissableIcon, onDismissableIconClick, dismissable, disabled, className } = _a, rest = __rest(_a, ["label", "iconName", "dismissableIcon", "onDismissableIconClick", "dismissable", "disabled", "className"]);
    const classList = classNames("tecma-tag", { disabled }, { dismissable }, className);
    const handleOnDismissClick = (e) => {
        if (onDismissableIconClick) {
            onDismissableIconClick();
            /**
             * Useful to avoid triggering some other event (e.g. Select component with multiple selection will trigger the select itself to open/close when dismissing tags)
             */
            e.stopPropagation();
        }
    };
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [iconName && _jsx(Icon, { iconName: iconName, size: "small" }), _jsx("span", { children: label }), dismissable && (_jsx(Button, { iconName: dismissableIcon, onClick: (e) => handleOnDismissClick(e), size: "small", color: "transparent" }))] })));
};
Tag.defaultProps = defaultProps;
export default React.memo(Tag);
